import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { SuppliersApi } from '@/api/SuppliersApi';

import { filter, orderBy } from 'lodash';

const state = {
   suppliers: [],
};

const mutations: MutationTree<any> = {
   SET_SUPPLIERS(state, items: any) {
      state.suppliers = orderBy(items, 'o_name');
   },
};

const getters: GetterTree<any, any> = {
   active(state) {
      return filter(state.suppliers, { o_city: 8, o_group: 39, o_active: 1 });
   },
};

const actions: ActionTree<any, any> = {
   GET_SUPPLIERS({ commit, state }) {
      return SuppliersApi.all({}).then(resp => {
         commit('SET_SUPPLIERS', resp);
         return resp.length;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
